<script lang="ts">
	import { NodeViewWrapper } from "svelte-tiptap";
	import DataToken from "#lib/components/DataToken.svelte";
	import type { NodeViewProps } from "@tiptap/core";
	import type { Node } from "@tiptap/pm/model";

	interface Props extends NodeViewProps {
		node: Node;
	}

	const { node }: Props = $props();
</script>

<NodeViewWrapper as="span" class="inline-block">
	<DataToken provider={node.attrs.provider} label={node.attrs.label} />
</NodeViewWrapper>
